import { SiteProperties } from '../../../graphql/horizon-schema'

export const title = (titleProps: {
  outOfStockNotification: boolean
  inStock: boolean
  siteProperties: SiteProperties
  choiceTitle: string
}) => {
  const notifySiteProperty =
    titleProps.siteProperties?.[
      'product.productoptions.dropdown.customlabel.text'
    ]?.value
  const unavailableSiteProperty =
    titleProps.siteProperties?.[
      'product.productoptions.dropdown.unavailable.text'
    ]?.value

  const title =
    titleProps.outOfStockNotification && notifySiteProperty
      ? `${titleProps.choiceTitle} - ${notifySiteProperty}`
      : !titleProps.inStock && unavailableSiteProperty
      ? `${titleProps.choiceTitle} - ${unavailableSiteProperty}`
      : titleProps.choiceTitle

  return title
}
